/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreatePassthroughChildDeviceRequest
 */
export interface CreatePassthroughChildDeviceRequest {
    /**
     * The id of the passthrough config to use
     * @type {number}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    passthroughConfigId?: number;
    /**
     * The id of the passthrough device in the third party system.
     * @type {string}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    thirdPartyDeviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    authorizationMode?: CreatePassthroughChildDeviceRequestAuthorizationModeEnum;
    /**
     * If AuthorizationMode=ManualBasicAuth, the 20 character unique secret key that will be sent to the charger. When IsAuthKeyHexString is true, provide the key as a 40 character hex representation instead. May be null.
     * @type {string}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    authorizationKey?: string;
    /**
     * Set to true to force passthrough creation of unsupported device models, if a previous call returned 1002 UnsupportedDeviceType.
     * @type {boolean}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    acknowledgeUnsupported?: boolean;
    /**
     * Used when AuthorizationMode=ManualBasicAuth. Set to true if AuthorizationKey is provided as a 40 character hex representation of the secret key
     * @type {boolean}
     * @memberof CreatePassthroughChildDeviceRequest
     */
    isAuthKeyHexString?: boolean;
}

/**
 * @export
 */
export const CreatePassthroughChildDeviceRequestAuthorizationModeEnum = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;
export type CreatePassthroughChildDeviceRequestAuthorizationModeEnum =
    (typeof CreatePassthroughChildDeviceRequestAuthorizationModeEnum)[keyof typeof CreatePassthroughChildDeviceRequestAuthorizationModeEnum];

/**
 * Check if a given object implements the CreatePassthroughChildDeviceRequest interface.
 */
export function instanceOfCreatePassthroughChildDeviceRequest(
    value: object,
): value is CreatePassthroughChildDeviceRequest {
    return true;
}

export function CreatePassthroughChildDeviceRequestFromJSON(
    json: any,
): CreatePassthroughChildDeviceRequest {
    return CreatePassthroughChildDeviceRequestFromJSONTyped(json, false);
}

export function CreatePassthroughChildDeviceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreatePassthroughChildDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        passthroughConfigId:
            json["passthroughConfigId"] == null
                ? undefined
                : json["passthroughConfigId"],
        thirdPartyDeviceIdentity:
            json["thirdPartyDeviceIdentity"] == null
                ? undefined
                : json["thirdPartyDeviceIdentity"],
        authorizationMode:
            json["authorizationMode"] == null
                ? undefined
                : json["authorizationMode"],
        authorizationKey:
            json["authorizationKey"] == null
                ? undefined
                : json["authorizationKey"],
        acknowledgeUnsupported:
            json["acknowledgeUnsupported"] == null
                ? undefined
                : json["acknowledgeUnsupported"],
        isAuthKeyHexString:
            json["isAuthKeyHexString"] == null
                ? undefined
                : json["isAuthKeyHexString"],
    };
}

export function CreatePassthroughChildDeviceRequestToJSON(
    value?: CreatePassthroughChildDeviceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        passthroughConfigId: value["passthroughConfigId"],
        thirdPartyDeviceIdentity: value["thirdPartyDeviceIdentity"],
        authorizationMode: value["authorizationMode"],
        authorizationKey: value["authorizationKey"],
        acknowledgeUnsupported: value["acknowledgeUnsupported"],
        isAuthKeyHexString: value["isAuthKeyHexString"],
    };
}
